import FirebaseApp from '@firebase/app';
import '@firebase/database';
import Config from '@/config';

if (!FirebaseApp.apps.length) {
  const config = {
    apiKey: Config.FirebaseKey,
    authDomain: Config.FirebaseDomain,
    databaseURL: Config.FirebaseDatabase,
    projectId: Config.FirebaseProjectId,
    storageBucket: Config.FirebaseStorageBucket,
    messagingSenderId: Config.FirebaseSenderId
  };
  FirebaseApp.initializeApp(config);
}

let FirebaseDatabase = FirebaseApp.database();
let ALL_CHANNELS = FirebaseDatabase.ref('all_channels');

export const Firebase = {
  getConciergeChannels: function(conciergeId) {
    return ALL_CHANNELS.orderByChild('agentId').equalTo(conciergeId || '');
  },

  getWaitingChannels: function() {
    return ALL_CHANNELS.orderByChild('status').equalTo('waiting');
  },

  getNewChannels() {
    ALL_CHANNELS.orderByChild('status')
      .equalTo('new')
      .on('value', channels => {
        this.newChannels = Object.values(channels.val());
      });
  },

  getArchivedChannels(conciergeId) {
    if (conciergeId) {
      return ALL_CHANNELS.orderByChild('lastAgentId')
        .equalTo(conciergeId)
        .limitToLast(200);
    } else {
      return ALL_CHANNELS.orderByChild('last_message_activity').limitToLast(
        200
      );
    }
  },

  getFirebaseDatabase() {
    return FirebaseDatabase;
  }
};
